import jQuery from 'jquery';

jQuery(($) => {
  'use strict';

  let signupForm = $('#Signup');

  if (signupForm.length > 0) {
    signupForm.on('submit', (e) => {
      if ($('#token').val() === '') {
        e.preventDefault();
        grecaptcha.enterprise.ready(() => {
          grecaptcha.enterprise.execute(
            window.recaptchaSiteKey,
            {
              action: 'signup'
            }
                    )
                    .then((token) => {
                      $('#token').val(token);
                      $('#Signup').submit();
                    });
        });
      }
    });
  }
});